import React, { useState,useEffect } from 'react'
import { TabbedPage, Tab } from 'components/Shared/TabbedPage'
import { FormProvider } from 'context/FormContext'
import ProjectInfo from 'components/Details/ProjectInfo'
import Tracking from 'components/Details/Tracking'
import Location from 'components/Details/Location'
import Organization from 'components/Details/Organization'
import CustomFields from 'components/Details/CustomFields'
import {getProjectInfo} from 'utils/DetailsUtils'
import { useAppContext } from 'hooks/useAppContext'
import { Divider } from '@material-ui/core'
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress'

const tabs = [
  new Tab({ label: "Project Info", value: "Project", scope: "Projects", action: "read"  }),
  new Tab({ label: "Tracking", value: "Tracking", scope: "Projects", action: "read"  }),
  new Tab({ label: "Custom Fields", value: "CustomFields", scope: "CustomFields", action: "update" })
]

const Details = () => {
  const [activeTab, setActiveTab] = useState("Project")
  const [detailsInfo, setDetailsInfo] = React.useState(undefined)
  const { selectedProject } = useAppContext()
  useEffect(() => {
    if (detailsInfo === undefined) {
      getProjectInfo(selectedProject).then(data => {
        setDetailsInfo(data)
      })
    }
  });

  const updateDetails = (tab) => {
    getProjectInfo(selectedProject).then(data => {
      setDetailsInfo(data)
      setActiveTab(tab)
    })
  };

  return (
      <TabbedPage
        tabs={tabs}
        activeTab={activeTab}
        tabSetterFunc={setActiveTab}
      >
        {detailsInfo ? (() => {
          switch (activeTab) {
            // case "GeneralInfo": return <GeneralInfo />
            case "Project":
              return (
                <>
                  <FormProvider key="info"><ProjectInfo CRUDType="UPDATE" callback={() => { updateDetails("Project") }}  defaultValues={detailsInfo}  /></FormProvider>
                  <Divider variant="middle" />
                  <FormProvider key="org"><Organization CRUDType="UPDATE" callback={() =>  {  updateDetails("Project")  }} defaultValues={detailsInfo}  /></FormProvider>
                </>
              )
            case "Tracking":
              return (
                <>
                  <FormProvider key="tracking"><Tracking CRUDType="UPDATE" callback={() => {  updateDetails("Tracking")  }}  defaultValues={detailsInfo}  /></FormProvider>
                  <Divider variant="middle" />
                  <FormProvider key="location"><Location CRUDType="UPDATE" callback={() =>  {  updateDetails("Tracking")  }} defaultValues={detailsInfo}  /></FormProvider>
                </>
                )
            case "CustomFields": 
              return <FormProvider><CustomFields CRUDType="UPDATE" callback={() => { setActiveTab("CustomFields") }} /></FormProvider>
            default: return <FormProvider><ProjectInfo CRUDType="UPDATE" callback={() => { setActiveTab("Project") }}  defaultValues={detailsInfo}  /></FormProvider>
          }
        })()
        :
        <CenteredCircularProgress />
        }

      </TabbedPage>
  )
}

export default Details